import { render, staticRenderFns } from "./VideoMeetingDetail.vue?vue&type=template&id=07f80fa8&scoped=true&"
import script from "./VideoMeetingDetail.vue?vue&type=script&lang=js&"
export * from "./VideoMeetingDetail.vue?vue&type=script&lang=js&"
import style0 from "./VideoMeetingDetail.vue?vue&type=style&index=0&id=07f80fa8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f80fa8",
  null
  
)

export default component.exports